import React from 'react';

import { Add, ArrowForwardIos, DensityLarge } from '@mui/icons-material';
import { Stack } from '@mui/material';

import DebugModal from '~/components/DebugModal/DebugModal';

import { exportItemInfo } from '~/services/PromoService';

function Internals({ internals }) {
  return (
    <>
      <Stack>
        <DebugModal title={`Order - ${internals.svcOrderOrder.total}`} type="generic" data={internals.svcOrderOrder} />
        <DebugModal
          title={`(${internals.calculator.asyncFields.user.givenName})`}
          type="generic"
          data={internals.calculator.asyncFields.user}
        />
      </Stack>
      <ArrowForwardIos />
      <Stack>
        <DebugModal
          title={`Promo Order - ${internals.promoOrder.items.length} items`}
          type="generic"
          data={internals.promoOrder}
        />
        {internals.promoOrder.items.map((item) => {
          const itemInfo = exportItemInfo(item.itemInfoString);
          return (
            <DebugModal
              key={item.itemId}
              title={`${item.categoryBK} - ${
                itemInfo?.promo_code_discount_amount ? `${itemInfo?.promo_code_discount_amount}/` : ''
              }${item.discountableTotal}`}
              type="generic"
              data={item}
            />
          );
        })}
      </Stack>
      <Add />
      <Stack>
        <DebugModal title="Promo" type="generic" data={internals.calculator.asyncFields.promo} />
        <DebugModal title="Discounts" type="generic" data={internals.calculator.asyncFields.promo?.promo_discounts} />
      </Stack>
      <DensityLarge />
    </>
  );
}

export default Internals;
